import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from "react";
import Animated from "react-native-web/dist/exports/Animated";
import DeviceEventEmitter from "react-native-web/dist/exports/DeviceEventEmitter";
import Dimensions from "react-native-web/dist/exports/Dimensions";
import KeyboardAvoidingView from "react-native-web/dist/exports/KeyboardAvoidingView";
import Modal from "react-native-web/dist/exports/Modal";
import PanResponder from "react-native-web/dist/exports/PanResponder";
import Platform from "react-native-web/dist/exports/Platform";
import TouchableWithoutFeedback from "react-native-web/dist/exports/TouchableWithoutFeedback";
import View from "react-native-web/dist/exports/View";
import PropTypes from "prop-types";
import * as animatable from "react-native-animatable";
import { initializeAnimations, buildAnimations } from "./utils";
import styles from "./index.style.js";
import { jsx as ___EmotionJSX } from "@emotion/core";
initializeAnimations();

var reversePercentage = function reversePercentage(x) {
  return -(x - 1);
};

var ReactNativeModal = function (_Component) {
  _inherits(ReactNativeModal, _Component);

  var _super = _createSuper(ReactNativeModal);

  function ReactNativeModal(props) {
    var _this;

    _classCallCheck(this, ReactNativeModal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      showContent: true,
      isVisible: false,
      deviceWidth: Dimensions.get("window").width,
      deviceHeight: Dimensions.get("window").height,
      isSwipeable: _this.props.swipeDirection ? true : false,
      pan: null
    });

    _defineProperty(_assertThisInitialized(_this), "isTransitioning", false);

    _defineProperty(_assertThisInitialized(_this), "inSwipeClosingState", false);

    _defineProperty(_assertThisInitialized(_this), "currentSwipingDirection", null);

    _defineProperty(_assertThisInitialized(_this), "buildPanResponder", function () {
      var animEvt = null;
      _this.panResponder = PanResponder.create({
        onMoveShouldSetPanResponder: function onMoveShouldSetPanResponder(evt, gestureState) {
          if (!_this.props.propagateSwipe) {
            var shouldSetPanResponder = Math.abs(gestureState.dx) >= 4 || Math.abs(gestureState.dy) >= 4;

            if (shouldSetPanResponder && _this.props.onSwipeStart) {
              _this.props.onSwipeStart();
            }

            _this.currentSwipingDirection = _this.getSwipingDirection(gestureState);
            animEvt = _this.createAnimationEventForSwipe();
            return shouldSetPanResponder;
          }
        },
        onStartShouldSetPanResponder: function onStartShouldSetPanResponder() {
          if (_this.props.scrollTo && _this.props.scrollOffset > 0) {
            return false;
          }

          if (_this.props.onSwipeStart) {
            _this.props.onSwipeStart();
          }

          _this.currentSwipingDirection = null;
          return true;
        },
        onPanResponderMove: function onPanResponderMove(evt, gestureState) {
          if (!_this.currentSwipingDirection) {
            if (gestureState.dx === 0 && gestureState.dy === 0) {
              return;
            }

            _this.currentSwipingDirection = _this.getSwipingDirection(gestureState);
            animEvt = _this.createAnimationEventForSwipe();
          }

          if (_this.isSwipeDirectionAllowed(gestureState)) {
            var newOpacityFactor = 1 - _this.calcDistancePercentage(gestureState);

            _this.backdropRef && _this.backdropRef.transitionTo({
              opacity: _this.props.backdropOpacity * newOpacityFactor
            });
            animEvt(evt, gestureState);

            if (_this.props.onSwipeMove) {
              _this.props.onSwipeMove(newOpacityFactor);
            }
          } else {
            if (_this.props.scrollTo) {
              if (_this.props.scrollHorizontal) {
                var offsetX = -gestureState.dx;

                if (offsetX > _this.props.scrollOffsetMax) {
                  offsetX -= (offsetX - _this.props.scrollOffsetMax) / 2;
                }

                _this.props.scrollTo({
                  x: offsetX,
                  animated: false
                });
              } else {
                var offsetY = -gestureState.dy;

                if (offsetY > _this.props.scrollOffsetMax) {
                  offsetY -= (offsetY - _this.props.scrollOffsetMax) / 2;
                }

                _this.props.scrollTo({
                  y: offsetY,
                  animated: false
                });
              }
            }
          }
        },
        onPanResponderRelease: function onPanResponderRelease(evt, gestureState) {
          var accDistance = _this.getAccDistancePerDirection(gestureState);

          if (accDistance > _this.props.swipeThreshold && _this.isSwipeDirectionAllowed(gestureState)) {
            if (_this.props.onSwipeComplete) {
              _this.inSwipeClosingState = true;

              _this.props.onSwipeComplete();

              return;
            }

            if (_this.props.onSwipe) {
              _this.inSwipeClosingState = true;

              _this.props.onSwipe();

              return;
            }
          }

          if (_this.props.onSwipeCancel) {
            _this.props.onSwipeCancel();
          }

          _this.backdropRef.transitionTo({
            opacity: _this.props.backdropOpacity
          });

          Animated.spring(_this.state.pan, {
            toValue: {
              x: 0,
              y: 0
            },
            bounciness: 0
          }).start();

          if (_this.props.scrollOffset > _this.props.scrollOffsetMax) {
            _this.props.scrollTo({
              y: _this.props.scrollOffsetMax,
              animated: true
            });
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getAccDistancePerDirection", function (gestureState) {
      switch (_this.currentSwipingDirection) {
        case "up":
          return -gestureState.dy;

        case "down":
          return gestureState.dy;

        case "right":
          return gestureState.dx;

        case "left":
          return -gestureState.dx;

        default:
          return 0;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getSwipingDirection", function (gestureState) {
      if (Math.abs(gestureState.dx) > Math.abs(gestureState.dy)) {
        return gestureState.dx > 0 ? "right" : "left";
      }

      return gestureState.dy > 0 ? "down" : "up";
    });

    _defineProperty(_assertThisInitialized(_this), "calcDistancePercentage", function (gestureState) {
      switch (_this.currentSwipingDirection) {
        case "down":
          return (gestureState.moveY - gestureState.y0) / ((_this.props.deviceHeight || _this.state.deviceHeight) - gestureState.y0);

        case "up":
          return reversePercentage(gestureState.moveY / gestureState.y0);

        case "left":
          return reversePercentage(gestureState.moveX / gestureState.x0);

        case "right":
          return (gestureState.moveX - gestureState.x0) / ((_this.props.deviceWidth || _this.state.deviceWidth) - gestureState.x0);

        default:
          return 0;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createAnimationEventForSwipe", function () {
      if (_this.currentSwipingDirection === "right" || _this.currentSwipingDirection === "left") {
        return Animated.event([null, {
          dx: _this.state.pan.x
        }]);
      } else {
        return Animated.event([null, {
          dy: _this.state.pan.y
        }]);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isDirectionIncluded", function (direction) {
      return Array.isArray(_this.props.swipeDirection) ? _this.props.swipeDirection.includes(direction) : _this.props.swipeDirection === direction;
    });

    _defineProperty(_assertThisInitialized(_this), "isSwipeDirectionAllowed", function (_ref) {
      var dy = _ref.dy,
          dx = _ref.dx;
      var draggedDown = dy > 0;
      var draggedUp = dy < 0;
      var draggedLeft = dx < 0;
      var draggedRight = dx > 0;

      if (_this.currentSwipingDirection === "up" && _this.isDirectionIncluded("up") && draggedUp) {
        return true;
      } else if (_this.currentSwipingDirection === "down" && _this.isDirectionIncluded("down") && draggedDown) {
        return true;
      } else if (_this.currentSwipingDirection === "right" && _this.isDirectionIncluded("right") && draggedRight) {
        return true;
      } else if (_this.currentSwipingDirection === "left" && _this.isDirectionIncluded("left") && draggedLeft) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "handleDimensionsUpdate", function (dimensionsUpdate) {
      if (!_this.props.deviceHeight && !_this.props.deviceWidth) {
        var deviceWidth = Dimensions.get("window").width;
        var deviceHeight = Dimensions.get("window").height;

        if (deviceWidth !== _this.state.deviceWidth || deviceHeight !== _this.state.deviceHeight) {
          _this.setState({
            deviceWidth: deviceWidth,
            deviceHeight: deviceHeight
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      if (_this.isTransitioning) return;
      _this.isTransitioning = true;

      if (_this.backdropRef) {
        _this.backdropRef.transitionTo({
          opacity: _this.props.backdropOpacity
        }, _this.props.backdropTransitionInTiming);
      }

      if (_this.state.isSwipeable) {
        _this.state.pan.setValue({
          x: 0,
          y: 0
        });
      }

      if (_this.contentRef) {
        _this.props.onModalWillShow && _this.props.onModalWillShow();

        _this.contentRef[_this.animationIn](_this.props.animationInTiming).then(function () {
          _this.isTransitioning = false;

          if (!_this.props.isVisible) {
            _this.close();
          } else {
            _this.props.onModalShow();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      if (_this.isTransitioning) return;
      _this.isTransitioning = true;

      if (_this.backdropRef) {
        _this.backdropRef.transitionTo({
          opacity: 0
        }, _this.props.backdropTransitionOutTiming);
      }

      var animationOut = _this.animationOut;

      if (_this.inSwipeClosingState) {
        _this.inSwipeClosingState = false;

        if (_this.currentSwipingDirection === "up") {
          animationOut = "slideOutUp";
        } else if (_this.currentSwipingDirection === "down") {
          animationOut = "slideOutDown";
        } else if (_this.currentSwipingDirection === "right") {
          animationOut = "slideOutRight";
        } else if (_this.currentSwipingDirection === "left") {
          animationOut = "slideOutLeft";
        }
      }

      if (_this.contentRef) {
        _this.props.onModalWillHide && _this.props.onModalWillHide();

        _this.contentRef[animationOut](_this.props.animationOutTiming).then(function () {
          _this.isTransitioning = false;

          if (_this.props.isVisible) {
            _this.open();
          } else {
            _this.setState({
              showContent: false
            }, function () {
              _this.setState({
                isVisible: false
              }, function () {
                _this.props.onModalHide();
              });
            });
          }
        });
      }
    });

    var _buildAnimations = buildAnimations(props),
        animationIn = _buildAnimations.animationIn,
        _animationOut = _buildAnimations.animationOut;

    _this.animationIn = animationIn;
    _this.animationOut = _animationOut;

    if (_this.state.isSwipeable) {
      _this.state = _objectSpread({}, _this.state, {
        pan: new Animated.ValueXY()
      });

      _this.buildPanResponder();
    }

    if (_this.props.isVisible) {
      _this.state = _objectSpread({}, _this.state, {
        isVisible: true,
        showContent: true
      });
    }

    return _this;
  }

  _createClass(ReactNativeModal, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!this.state.isVisible && nextProps.isVisible) {
        this.setState({
          isVisible: true,
          showContent: true
        });
      }

      if (this.props.animationIn !== nextProps.animationIn || this.props.animationOut !== nextProps.animationOut) {
        var _buildAnimations2 = buildAnimations(nextProps),
            animationIn = _buildAnimations2.animationIn,
            animationOut = _buildAnimations2.animationOut;

        this.animationIn = animationIn;
        this.animationOut = animationOut;
      }

      if (this.props.backdropOpacity !== nextProps.backdropOpacity && this.backdropRef) {
        this.backdropRef.transitionTo({
          opacity: nextProps.backdropOpacity
        }, this.props.backdropTransitionInTiming);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onSwipe) {
        console.warn('`<Modal onSwipe="..." />` is deprecated. Use `<Modal onSwipeComplete="..." />` instead.');
      }

      if (this.state.isVisible) {
        this.open();
      }

      DeviceEventEmitter.addListener("didUpdateDimensions", this.handleDimensionsUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      DeviceEventEmitter.removeListener("didUpdateDimensions", this.handleDimensionsUpdate);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.isVisible && !prevProps.isVisible) {
        this.open();
      } else if (!this.props.isVisible && prevProps.isVisible) {
        this.close();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          animationIn = _this$props.animationIn,
          animationInTiming = _this$props.animationInTiming,
          animationOut = _this$props.animationOut,
          animationOutTiming = _this$props.animationOutTiming,
          avoidKeyboard = _this$props.avoidKeyboard,
          coverScreen = _this$props.coverScreen,
          hasBackdrop = _this$props.hasBackdrop,
          backdropColor = _this$props.backdropColor,
          backdropOpacity = _this$props.backdropOpacity,
          backdropTransitionInTiming = _this$props.backdropTransitionInTiming,
          backdropTransitionOutTiming = _this$props.backdropTransitionOutTiming,
          children = _this$props.children,
          deviceHeightProp = _this$props.deviceHeight,
          deviceWidthProp = _this$props.deviceWidth,
          isVisible = _this$props.isVisible,
          onModalShow = _this$props.onModalShow,
          onBackdropPress = _this$props.onBackdropPress,
          onBackButtonPress = _this$props.onBackButtonPress,
          useNativeDriver = _this$props.useNativeDriver,
          propagateSwipe = _this$props.propagateSwipe,
          style = _this$props.style,
          otherProps = _objectWithoutProperties(_this$props, ["animationIn", "animationInTiming", "animationOut", "animationOutTiming", "avoidKeyboard", "coverScreen", "hasBackdrop", "backdropColor", "backdropOpacity", "backdropTransitionInTiming", "backdropTransitionOutTiming", "children", "deviceHeight", "deviceWidth", "isVisible", "onModalShow", "onBackdropPress", "onBackButtonPress", "useNativeDriver", "propagateSwipe", "style"]);

      var deviceWidth = deviceWidthProp || this.state.deviceWidth;
      var deviceHeight = deviceHeightProp || this.state.deviceHeight;
      var computedStyle = [{
        margin: deviceWidth * 0.05,
        transform: [{
          translateY: 0
        }]
      }, styles.content, style];
      var panHandlers = {};
      var panPosition = {};

      if (this.state.isSwipeable) {
        panHandlers = _objectSpread({}, this.panResponder.panHandlers);

        if (useNativeDriver) {
          panPosition = {
            transform: this.state.pan.getTranslateTransform()
          };
        } else {
          panPosition = this.state.pan.getLayout();
        }
      }

      var _children = this.props.hideModalContentWhileAnimating && this.props.useNativeDriver && !this.state.showContent ? ___EmotionJSX(animatable.View, null) : children;

      var containerView = ___EmotionJSX(animatable.View, _extends({}, panHandlers, {
        ref: function ref(_ref2) {
          return _this2.contentRef = _ref2;
        },
        style: [panPosition, computedStyle],
        pointerEvents: "box-none",
        useNativeDriver: useNativeDriver
      }, otherProps), _children);

      var backdrop = ___EmotionJSX(TouchableWithoutFeedback, {
        onPress: onBackdropPress
      }, ___EmotionJSX(animatable.View, {
        ref: function ref(_ref3) {
          return _this2.backdropRef = _ref3;
        },
        useNativeDriver: true,
        style: [styles.backdrop, {
          backgroundColor: this.state.showContent ? backdropColor : "transparent",
          width: deviceWidth,
          height: deviceHeight
        }]
      }));

      if (!coverScreen && this.state.isVisible) return ___EmotionJSX(View, {
        pointerEvents: "box-none",
        style: [styles.backdrop, {
          zIndex: 2,
          opacity: 1,
          backgroundColor: "transparent"
        }]
      }, hasBackdrop && backdrop, containerView);
      return ___EmotionJSX(Modal, _extends({
        transparent: true,
        animationType: "none",
        visible: this.state.isVisible,
        onRequestClose: onBackButtonPress
      }, otherProps), hasBackdrop && backdrop, avoidKeyboard && ___EmotionJSX(KeyboardAvoidingView, {
        behavior: Platform.OS === "ios" ? "padding" : null,
        pointerEvents: "box-none",
        style: computedStyle.concat([{
          margin: 0
        }])
      }, containerView), !avoidKeyboard && containerView);
    }
  }]);

  return ReactNativeModal;
}(Component);

_defineProperty(ReactNativeModal, "propTypes", {
  animationIn: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  animationInTiming: PropTypes.number,
  animationOut: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  animationOutTiming: PropTypes.number,
  avoidKeyboard: PropTypes.bool,
  coverScreen: PropTypes.bool,
  hasBackdrop: PropTypes.bool,
  backdropColor: PropTypes.string,
  backdropOpacity: PropTypes.number,
  backdropTransitionInTiming: PropTypes.number,
  backdropTransitionOutTiming: PropTypes.number,
  children: PropTypes.node.isRequired,
  deviceHeight: PropTypes.number,
  deviceWidth: PropTypes.number,
  isVisible: PropTypes.bool.isRequired,
  hideModalContentWhileAnimating: PropTypes.bool,
  propagateSwipe: PropTypes.bool,
  onModalShow: PropTypes.func,
  onModalWillShow: PropTypes.func,
  onModalHide: PropTypes.func,
  onModalWillHide: PropTypes.func,
  onBackButtonPress: PropTypes.func,
  onBackdropPress: PropTypes.func,
  onSwipeStart: PropTypes.func,
  onSwipeMove: PropTypes.func,
  onSwipeComplete: PropTypes.func,
  onSwipeCancel: PropTypes.func,
  swipeThreshold: PropTypes.number,
  swipeDirection: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOf(["up", "down", "left", "right"])), PropTypes.oneOf(["up", "down", "left", "right"])]),
  useNativeDriver: PropTypes.bool,
  style: PropTypes.any,
  scrollTo: PropTypes.func,
  scrollOffset: PropTypes.number,
  scrollOffsetMax: PropTypes.number,
  scrollHorizontal: PropTypes.bool,
  supportedOrientations: PropTypes.arrayOf(PropTypes.oneOf(["portrait", "portrait-upside-down", "landscape", "landscape-left", "landscape-right"]))
});

_defineProperty(ReactNativeModal, "defaultProps", {
  animationIn: "slideInUp",
  animationInTiming: 300,
  animationOut: "slideOutDown",
  animationOutTiming: 300,
  avoidKeyboard: false,
  coverScreen: true,
  hasBackdrop: true,
  backdropColor: "black",
  backdropOpacity: 0.7,
  backdropTransitionInTiming: 300,
  backdropTransitionOutTiming: 300,
  onModalShow: function onModalShow() {
    return null;
  },
  onModalWillShow: function onModalWillShow() {
    return null;
  },
  deviceHeight: null,
  deviceWidth: null,
  onModalHide: function onModalHide() {
    return null;
  },
  onModalWillHide: function onModalWillHide() {
    return null;
  },
  isVisible: false,
  hideModalContentWhileAnimating: false,
  propagateSwipe: PropTypes["false"],
  onBackdropPress: function onBackdropPress() {
    return null;
  },
  onBackButtonPress: function onBackButtonPress() {
    return null;
  },
  swipeThreshold: 100,
  useNativeDriver: false,
  scrollTo: null,
  scrollOffset: 0,
  scrollOffsetMax: 0,
  scrollHorizontal: false,
  supportedOrientations: ["portrait", "landscape"]
});

export default ReactNativeModal;

if (typeof ReactNativeModal !== 'undefined' && ReactNativeModal && ReactNativeModal === Object(ReactNativeModal) && Object.isExtensible(ReactNativeModal) && !ReactNativeModal.hasOwnProperty('__filemeta')) {
  Object.defineProperty(ReactNativeModal, '__filemeta', {
    configurable: true,
    value: {
      name: "ReactNativeModal",
      filename: "node_modules/react-native-modal/src/index.js"
    }
  });
}

export { ReactNativeModal };

if (typeof ReactNativeModal !== 'undefined' && ReactNativeModal && ReactNativeModal === Object(ReactNativeModal) && Object.isExtensible(ReactNativeModal) && !ReactNativeModal.hasOwnProperty('__filemeta')) {
  Object.defineProperty(ReactNativeModal, '__filemeta', {
    configurable: true,
    value: {
      name: "ReactNativeModal",
      filename: "node_modules/react-native-modal/src/index.js"
    }
  });
}